var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 100,
    viewBox: "0 0 165 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9B\xD0\xBE\xD0\xB3\xD0\xBE (\xD0\xB1\xD0\xBE\xD0\xBB\xD1\x8C\xD1\x88\xD0\xBE\xD0\xB9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.98633 43.6172H23.6262V64.7444H17.9023V48.1837H7.71022V64.7444H1.98633V43.6172ZM25.8734 64.7444L36.3282 43.6172H42.5194L52.9743 64.7444H47.1919L45.2353 60.6403H33.7875L31.8309 64.7444H25.8734ZM39.4822 48.6461L35.8318 56.334H43.1619L39.4822 48.6461ZM68.3146 58.2126H60.9553V64.7444H55.2314V43.6172H68.3146C72.6367 43.6172 76.6376 44.8889 76.6376 51.016C76.6376 57.1721 72.5491 58.2126 68.3146 58.2126ZM71.0013 51.016C71.0013 48.7906 69.8624 48.2704 68.4898 48.2704H60.9553V53.7328H68.4898C69.8624 53.7328 71.0013 53.2126 71.0013 51.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M96.9557 36.2578V51.2L107.527 36.2578H113.28V57.385H107.995V42.8474L97.3937 57.385H91.6406V36.2578H96.9557ZM133.167 36.2578H138.89V57.385H133.167V49.148H122.975V57.385H117.251V36.2578H122.975V44.4948H133.167V36.2578ZM148.585 40.8243V57.385H142.861V36.2578H161.785V40.8243H148.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_1973_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.768 34.7244C111.758 34.7042 111.749 34.6839 111.739 34.664C108.254 27.5522 99.6034 24.583 92.4173 28.032C85.2315 31.481 82.2311 40.042 85.7162 47.1539C85.7262 47.1738 85.7361 47.194 85.746 47.2143L79.177 50.3672C79.167 50.3469 79.1571 50.327 79.1472 50.3068C73.9025 39.6044 78.4174 26.7211 89.2315 21.5308C100.046 16.3404 113.063 20.8087 118.308 31.5108C118.318 31.531 118.328 31.5513 118.337 31.5715L111.768 34.7244Z",
    fill: "#B63940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter1_d_1973_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.484 53.7391C80.4934 53.7579 80.5027 53.7767 80.5121 53.7958C83.5048 59.903 80.8178 68.1336 73.2474 71.7672C65.6767 75.4007 57.4824 72.3929 54.4897 66.2856C54.4803 66.2669 54.471 66.2478 54.4619 66.2287L47.8926 69.3819C47.9019 69.4007 47.9113 69.4198 47.9203 69.4385C52.8537 79.5056 65.6191 83.4588 76.4332 78.2683C87.247 73.0778 92.0145 60.7096 87.0811 50.6429C87.0721 50.6238 87.0627 50.605 87.0534 50.5859L80.484 53.7391Z",
    fill: "#B63940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xB8 \xD1\x82\xD0\xB0\xD1\x80\xD0\xB3\xD0\xB5\xD1\x82\xD0\xB8\xD0\xBD\xD0\xB3",
    filter: "url(#filter2_d_1973_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M163.536 62.1172V63.7959H160.762V69.1032H158.568V62.1172H163.536Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M155.991 64.8419V66.5141H152.475V64.8419H155.991ZM153.276 62.1172V69.1032H151.082V62.1172H153.276ZM157.397 62.1172V69.1032H155.197V62.1172H157.397Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M145.796 66.1719L147.736 62.1172H149.93V69.1032H147.736V65.0356L145.796 69.1032H143.596V62.1172H145.796V66.1719Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M140.587 62.1172V69.1032H138.387V62.1172H140.587ZM142.814 62.1172V63.783H136.199V62.1172H142.814Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M132.865 69.2287C132.292 69.2287 131.78 69.1405 131.329 68.964C130.877 68.7832 130.495 68.5357 130.183 68.2215C129.875 67.9072 129.638 67.5457 129.473 67.1368C129.313 66.7278 129.232 66.2952 129.232 65.839V65.5936C129.232 65.0814 129.304 64.6079 129.447 64.1732C129.59 63.7341 129.803 63.351 130.085 63.0239C130.367 62.6968 130.721 62.4428 131.146 62.262C131.572 62.0769 132.067 61.9844 132.631 61.9844C133.13 61.9844 133.577 62.064 133.972 62.2233C134.367 62.3825 134.701 62.6107 134.975 62.9077C135.252 63.2047 135.463 63.5641 135.606 63.9859C135.754 64.4078 135.827 64.8812 135.827 65.4064V66.2909H130.072V64.9286H133.686V64.7607C133.69 64.5283 133.649 64.3303 133.562 64.1667C133.479 64.0031 133.358 63.8783 133.197 63.7922C133.037 63.7061 132.841 63.6631 132.611 63.6631C132.373 63.6631 132.175 63.7147 132.019 63.8181C131.867 63.9214 131.748 64.0634 131.661 64.2442C131.578 64.4207 131.52 64.6251 131.485 64.8576C131.45 65.09 131.433 65.3354 131.433 65.5936V65.839C131.433 66.0972 131.468 66.3318 131.537 66.5427C131.611 66.7537 131.715 66.9344 131.85 67.0851C131.988 67.2314 132.153 67.3455 132.344 67.4273C132.54 67.5091 132.761 67.55 133.008 67.55C133.308 67.55 133.603 67.494 133.894 67.3821C134.185 67.2702 134.434 67.0851 134.643 66.8268L135.639 68.0019C135.495 68.2042 135.291 68.4001 135.027 68.5895C134.766 68.7789 134.454 68.9338 134.089 69.0544C133.725 69.1706 133.317 69.2287 132.865 69.2287Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M128.926 62.1172V63.7959H126.153V69.1032H123.959V62.1172H128.926Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M118.7 63.4565V71.7855H116.506V62.1135H118.55L118.7 63.4565ZM123.023 65.5226V65.6582C123.023 66.1661 122.964 66.6374 122.847 67.0722C122.73 67.5069 122.556 67.8857 122.326 68.2085C122.096 68.5314 121.81 68.7832 121.467 68.964C121.128 69.1405 120.735 69.2287 120.288 69.2287C119.867 69.2287 119.505 69.1361 119.201 68.9511C118.897 68.766 118.643 68.5099 118.439 68.1827C118.235 67.8556 118.071 67.4811 117.945 67.0593C117.819 66.6374 117.719 66.1919 117.645 65.7228V65.5484C117.719 65.0448 117.819 64.5778 117.945 64.1473C118.071 63.7126 118.235 63.3338 118.439 63.011C118.643 62.6881 118.895 62.4363 119.195 62.2556C119.498 62.0748 119.861 61.9844 120.282 61.9844C120.729 61.9844 121.122 62.0683 121.46 62.2362C121.803 62.4041 122.09 62.6451 122.32 62.9593C122.554 63.2692 122.73 63.6416 122.847 64.0763C122.964 64.5111 123.023 64.9932 123.023 65.5226ZM120.829 65.6582V65.5226C120.829 65.2514 120.809 65.0039 120.77 64.7801C120.731 64.552 120.668 64.354 120.581 64.1861C120.499 64.0182 120.388 63.8891 120.249 63.7987C120.11 63.7083 119.939 63.6631 119.735 63.6631C119.501 63.6631 119.303 63.6997 119.143 63.7729C118.986 63.8417 118.86 63.9493 118.765 64.0957C118.674 64.2377 118.609 64.4164 118.57 64.6316C118.535 64.8425 118.52 65.09 118.524 65.3741V65.9035C118.515 66.2307 118.548 66.5191 118.622 66.7687C118.696 67.0141 118.824 67.2056 119.006 67.3434C119.188 67.4811 119.436 67.55 119.748 67.55C119.956 67.55 120.13 67.5026 120.269 67.4079C120.408 67.3089 120.518 67.1733 120.601 67.0012C120.683 66.8247 120.742 66.6224 120.777 66.3942C120.811 66.1661 120.829 65.9208 120.829 65.6582Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M113.062 67.3434V64.4637C113.062 64.2657 113.034 64.0957 112.977 63.9536C112.921 63.8116 112.832 63.7018 112.71 63.6244C112.589 63.5426 112.426 63.5017 112.222 63.5017C112.057 63.5017 111.916 63.5297 111.799 63.5856C111.682 63.6416 111.593 63.7255 111.532 63.8374C111.471 63.9493 111.441 64.0914 111.441 64.2636H109.247C109.247 63.9407 109.318 63.6416 109.462 63.3661C109.609 63.0863 109.817 62.8431 110.087 62.6365C110.36 62.4299 110.686 62.2706 111.063 62.1587C111.445 62.0425 111.87 61.9844 112.339 61.9844C112.899 61.9844 113.398 62.0769 113.837 62.262C114.279 62.4471 114.629 62.7247 114.885 63.0949C115.141 63.4608 115.269 63.9214 115.269 64.4766V67.3369C115.269 67.7932 115.295 68.1397 115.347 68.3764C115.399 68.6089 115.473 68.8133 115.568 68.9898V69.0996H113.368C113.264 68.8843 113.186 68.6218 113.133 68.3119C113.086 67.9976 113.062 67.6748 113.062 67.3434ZM113.329 64.8317L113.342 65.9939H112.372C112.168 65.9939 111.994 66.0219 111.851 66.0779C111.712 66.1338 111.599 66.2113 111.512 66.3103C111.43 66.405 111.369 66.5126 111.33 66.6331C111.295 66.7537 111.278 66.8806 111.278 67.0141C111.278 67.1432 111.308 67.2594 111.369 67.3627C111.434 67.4617 111.521 67.5392 111.63 67.5952C111.738 67.6511 111.86 67.6791 111.994 67.6791C112.237 67.6791 112.443 67.6339 112.613 67.5435C112.786 67.4488 112.919 67.3348 113.01 67.2013C113.101 67.0679 113.146 66.9431 113.146 66.8268L113.628 67.7178C113.541 67.89 113.442 68.0644 113.329 68.2408C113.22 68.4173 113.084 68.5809 112.919 68.7315C112.758 68.8779 112.561 68.9984 112.326 69.0931C112.092 69.1835 111.808 69.2287 111.473 69.2287C111.039 69.2287 110.64 69.1405 110.275 68.964C109.915 68.7875 109.627 68.5421 109.41 68.2279C109.192 67.9094 109.084 67.5435 109.084 67.1303C109.084 66.7687 109.149 66.4459 109.279 66.1618C109.414 65.8777 109.616 65.6367 109.885 65.4387C110.154 65.2407 110.497 65.09 110.913 64.9867C111.33 64.8834 111.821 64.8317 112.385 64.8317H113.329Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M106.46 62.1172V69.1032H104.26V62.1172H106.46ZM108.687 62.1172V63.783H102.072V62.1172H108.687Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M93.8685 66.1719L95.8086 62.1172H98.0026V69.1032H95.8086V65.0356L93.8685 69.1032H91.668V62.1172H93.8685V66.1719Z",
    fill: "#8586A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1973_1538",
    x: 75.9609,
    y: 19.3672,
    width: 43.377,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_1538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1973_1538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1973_1538",
    x: 47.8926,
    y: 50.5859,
    width: 43.1348,
    height: 31.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_1538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1973_1538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1973_1538",
    x: 90.668,
    y: 61.9844,
    width: 73.8672,
    height: 11.8047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_1538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1973_1538",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/Logo_big.b87dab56398438068b82c2fe25653042.svg";
export { ForwardRef as ReactComponent };